it("should load single file modules", function() {
	require("subfilemodule").should.be.eql("subfilemodule");
});



/*****************
 ** WEBPACK FOOTER
 ** ./resolving/single-file-module/index.js
 ** module id = 0
 ** module chunks = 0
 **/